import { render, staticRenderFns } from "./SubscribeCatalog.vue?vue&type=template&id=40fbc6fe&scoped=true&"
import script from "./SubscribeCatalog.vue?vue&type=script&lang=js&"
export * from "./SubscribeCatalog.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeCatalog.vue?vue&type=style&index=0&id=40fbc6fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fbc6fe",
  null
  
)

export default component.exports